import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { Maybe } from '@soundxyz/utils';
import { ListeningPartyCountdown } from '@components/Countdown/ListeningPartyCountdown';
import type { CurrentListeningParty } from '@hooks/usePlayButton';
import { useTimer } from '@hooks/useTimer';

export const Countdown = ({
  mintStartTimestamp,
  listeningParty,
  currentListeningParty,
  releaseCard = false,
  className,
  onCountdownExpire,
  small = false,
}: {
  mintStartTimestamp: number;
  currentListeningParty: CurrentListeningParty;
  listeningParty: Maybe<number>;
  releaseCard?: boolean;
  className?: string;
  onCountdownExpire?: () => void;
  small?: boolean;
}) => {
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp:
      currentListeningParty?.listeningParty ?? (listeningParty != null ? 1 : mintStartTimestamp),
    onExpire: onCountdownExpire ? () => setTimeout(onCountdownExpire, 1000) : undefined,
  });

  return (
    <div
      className={twMerge('flex flex-col items-center gap-4 text-white lt:items-start', className)}
    >
      <p
        className={twMerge(
          'font-kicker text-kicker-s uppercase',
          small ? 'opacity-50' : 'opacity-100',
        )}
      >
        {releaseCard || (
          <>
            {listeningParty != null ? (
              <>
                <span className="hidden dt:block">🎧 Listening Party Begins In...</span>
                <span className="block dt:hidden">Listening Party</span>
              </>
            ) : (
              <>
                <span className="hidden dt:block">Release Party Begins...</span>
                <span className="block dt:hidden">Release Party</span>
              </>
            )}
          </>
        )}
      </p>
      <ListeningPartyCountdown
        seconds={seconds}
        minutes={minutes}
        hours={hours}
        days={days}
        variant={releaseCard ? 'feedReleaseDropped' : 'release'}
        small={small}
      />
    </div>
  );
};
